import { forwardRef, useMemo, useRef, useState } from 'react';
import { Button, Col, Collapse } from 'react-bootstrap';
import {
  BsCaretDownSquareFill,
  BsCaretUpSquareFill,
  BsExclamationLg,
} from 'react-icons/bs';
import { Link } from 'react-router-dom';

import styles from '@containers/Dashboard/Dashboard.module.scss';

import { BootstrapTable } from '@components/Table/Table';

const renderStatusCell = ({ value, uuid }) => {
  const detailsURL = `/order/open/${uuid}/details`;
  return (
    <Button size="sm" variant="danger" as={Link} to={detailsURL}>
      {value}
    </Button>
  );
};
export const CollapseDocuments = forwardRef(({ data, uuid }, ref) => {
  const [open, setOpen] = useState(false);
  const rowRef = useRef(null);
  const columns = useMemo(() => [
    { Header: 'Country', accessor: 'country' },
    { Header: 'Area', accessor: 'area' },
    { Header: 'Data/ Document', accessor: 'document_type' },
    {
      Header: 'Status',
      accessor: 'status',
      className: 'text-center',
      Cell: ({ value }) => renderStatusCell({ value, uuid }),
    },
  ]);
  const caretProps = {
    className: styles.orderDocumentsCaret,
    onClick: () => {
      setOpen(!open);
      setTimeout(() => {
        ref.current.scroll({
          top: rowRef.current?.offsetParent?.offsetTop,
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        });
      }, 400);
    },
    'aria-controls': `collapse-documents-${uuid}`,
    'aria-expanded': open,
  };
  return (
    <>
      <Col className="text-end">
        <BsExclamationLg className="textRed" size={24} />
        {open ? (
          <BsCaretUpSquareFill
            className={caretProps.className}
            onClick={caretProps.onClick}
            aria-controls={caretProps['aria-controls']}
            aria-expanded={caretProps['aria-expanded']}
          />
        ) : (
          <BsCaretDownSquareFill
            className={caretProps.className}
            onClick={caretProps.onClick}
            aria-controls={caretProps['aria-controls']}
            aria-expanded={caretProps['aria-expanded']}
          />
        )}
      </Col>
      <Collapse in={open}>
        <div id={`collapse-documents-${uuid}`} className="py-1" ref={rowRef}>
          <BootstrapTable
            columns={columns}
            data={data}
            tableProps={() => ({ bordered: true })}
          />
        </div>
      </Collapse>
    </>
  );
});
